import type { JSX } from 'react';
import type { UnitFormErrors, UnitFormState } from './unitFormState';
import { UnitIdentitySection } from './UnitIdentitySection';
import { UnitAvailabilitySection } from './UnitAvailabilitySection';
import { UnitMediaSection } from './UnitMediaSection';
import { UnitPublishSection } from './UnitPublishSection';
import { UnitPricingSection } from './UnitPricingSection';
import { UnitExtrasSection } from './UnitExtrasSection';

interface UnitFormFieldsProps {
  propertyId: string;
  formState: UnitFormState;
  errors: UnitFormErrors;
  disabled: boolean;
  isUploadingHero: boolean;
  setFormState: React.Dispatch<React.SetStateAction<UnitFormState>>;
  clearFieldError: (field: keyof UnitFormState) => void;
  onUploadingHeroChange: (uploading: boolean) => void;
}

export function UnitFormFields({
  propertyId,
  formState,
  errors,
  disabled,
  isUploadingHero,
  setFormState,
  clearFieldError,
  onUploadingHeroChange,
}: UnitFormFieldsProps): JSX.Element {
  return (
    <>
      <UnitIdentitySection
        formState={formState}
        errors={errors}
        disabled={disabled}
        isUploadingHero={isUploadingHero}
        setFormState={setFormState}
        clearFieldError={clearFieldError}
      />
      <UnitAvailabilitySection
        formState={formState}
        errors={errors}
        disabled={disabled}
        isUploadingHero={isUploadingHero}
        setFormState={setFormState}
        clearFieldError={clearFieldError}
      />
      <UnitMediaSection
        propertyId={propertyId}
        formState={formState}
        errors={errors}
        disabled={disabled}
        isUploadingHero={isUploadingHero}
        setFormState={setFormState}
        clearFieldError={clearFieldError}
        onUploadingHeroChange={onUploadingHeroChange}
      />
      <UnitPublishSection
        formState={formState}
        errors={errors}
        disabled={disabled}
        isUploadingHero={isUploadingHero}
        setFormState={setFormState}
        clearFieldError={clearFieldError}
      />
      <UnitPricingSection
        formState={formState}
        errors={errors}
        disabled={disabled}
        isUploadingHero={isUploadingHero}
        setFormState={setFormState}
        clearFieldError={clearFieldError}
      />
      <UnitExtrasSection
        formState={formState}
        errors={errors}
        disabled={disabled}
        isUploadingHero={isUploadingHero}
        setFormState={setFormState}
        clearFieldError={clearFieldError}
      />
    </>
  );
}
